<script>
  import Nav from '$lib/components/website/nav/Nav.svelte';
  import { page } from '$app/stores';

  export let data;
</script>

{#if !$page?.data?.pageData?.timedCouponId && !$page?.data?.pageData?.timedCouponDuration}
  <Nav
    headerNavigation={data?.headerNavigation}
    headerCta={data.headerCta}
    headerCtaBackground={data?.headerCtaBackground}
    headerCtaTextColour={data?.headerCtaTextColour}
  />
{/if}
<slot />
